var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('a',{staticClass:"logo",on:{"click":function($event){_vm.changeContentsName('Main')}}},[_c('img',{attrs:{"src":"img/logo.png","alt":"지미추로고"}})]),_vm._v(" "),_c('img',{staticClass:"join",attrs:{"src":"img/txt_join.png","alt":"사용자영역"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e49ecf6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 47
// module chunks = 0